var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextGroup w-card"},[_c('p',{staticClass:"text__psb"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"sp__v__1s5x"}),_c('p',{staticClass:"text__pr"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }